import { Autocomplete, TextField } from '@mui/material';
import { Control, Controller, UseFormGetValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';

type Props = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  fixedTermReasons: Enum[];
  index: number;
};

export const FixedTermReasonComponent = ({
  control,
  fixedTermReasons,
  index,
  getValues,
}: Props) => {
  const { t } = useTranslation();

  const { filterActiveEnumsByFormSelections } =
    useFilterActiveEnumsByFormSelections({
      control,
      index,
      getValues,
    });

  const filteredOptions = filterActiveEnumsByFormSelections(fixedTermReasons);

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employment.fEmplFixedTermReason`}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          options={filteredOptions}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          onChange={(_, value) => onChange(value?.code || '')}
          value={filteredOptions.find((o) => o?.code === value) || null}
          size={'small'}
          data-testid="fixed-term-reason-autocomplete"
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('fReasonFixTerm')}
              error={!!error}
              helperText={error?.message}
              data-testid="fixed-term-reason-input"
              InputLabelProps={{ shrink: true }}
            />
          )}
          fullWidth={true}
        />
      )}
    />
  );
};
